import { initAndBind } from "@jupiter/core";
import { Logger } from "@jupiter/utils";
import { BrowserClient } from "./client";
import { GlobalHandlers } from "./integrations";
import { BrowserOptions } from "./types/options";

export const defaultIntegrations = [new GlobalHandlers()];

const DEFAULT_ENDPOINT = "https://wifi.12306.cn/wifiapps/applog/logApi/send";

export function init(options: BrowserOptions) {
  if (options.debug === true) {
    Logger.enable();
  }

  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }

  if (options.endpoint === undefined) {
    options.endpoint = DEFAULT_ENDPOINT;
  }

  initAndBind(BrowserClient, options);
}
